import { NotificationScreen } from "@components/Onboarding/NotificationScreen";

export default NotificationScreen;
